"use client";

import { AnimatePresence, m } from "motion/react";
import { SPRING_FAST } from "@/lib/motion";
import { cn } from "@/lib/utils";

type Variant = "orange" | "sky";

const badgeVariants: Record<Variant, string> = {
  orange: "border-orange-500 bg-orange-500/15 text-orange-500",
  sky: "border-sky-400 bg-sky-400/15 text-sky-400",
};

const bandVariants: Record<Variant, string> = {
  orange: "bg-orange-500/20",
  sky: "bg-sky-400/20",
};

const POP = { filter: "blur(4px)", opacity: 0, scale: 0.75 };
const REST = { filter: "blur(0px)", opacity: 1, scale: 1 };

export function MeasurementBadge({
  children,
  className,
  show,
  variant = "orange",
}: {
  children: React.ReactNode;
  className?: string;
  show: boolean;
  variant?: Variant;
}) {
  return (
    <AnimatePresence initial={false}>
      {show && (
        <m.div
          animate={REST}
          className={cn(
            "pointer-events-none absolute flex select-none items-center justify-center rounded-full border px-2 font-medium text-sm will-change-transform",
            badgeVariants[variant],
            className
          )}
          exit={POP}
          initial={POP}
          transition={SPRING_FAST}
        >
          {children}
        </m.div>
      )}
    </AnimatePresence>
  );
}

export function MeasurementBand({
  className,
  show,
  style,
  variant = "orange",
}: {
  className?: string;
  show: boolean;
  style?: React.CSSProperties;
  variant?: Variant;
}) {
  return (
    <AnimatePresence initial={false}>
      {show && (
        <m.div
          animate={{ opacity: 1 }}
          className={cn(
            "pointer-events-none absolute select-none",
            bandVariants[variant],
            className
          )}
          exit={{ opacity: 0 }}
          initial={{ opacity: 0 }}
          style={style}
          transition={SPRING_FAST}
        />
      )}
    </AnimatePresence>
  );
}
